const SDK_VERSION = '8.35.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
